import {AxiosResponse} from "axios";

export interface IAxiosGetResponse{
  response : AxiosResponse;
  data: any;
}

export interface IServiceDto {
    id: string;
    name: string;
    code: string;
    ownerId: string;
    isApproved: boolean;
    isDeleted: boolean;
    institutionId: string;
}
 export interface IInstitutionDto {
  name: string;
  id: string;
  isDeleted?: boolean;
}

export interface ILibraryWithClassNamesDto {
    id: number;
    name: string;
    libraryPath: string;
    classNames: string;
}
export interface ILibraryDto {
    id: number;
    name: string;
    libraryPath: string;
}
export interface ILibraryContentDto {
    name: string;
    relativePath: string;
    files: string[];
    folders: ILibraryContentDto[];
}

export interface ILibraryFileSyncInfo {
    fileName: string;
    isDependency: boolean;
    isTemplate: boolean;
    dependencyOrder?: number;
    size: number;
    hash: string;
}

export interface ILibraryFileSyncMismatch {
    fileName: string;
    localHash: string;
    remoteHash: string;
}

export interface ILibrarySyncComparisonDto {
    isInSync: boolean;
    localFileCount: number;
    transformationFileCount: number;
    missingInTransformation: ILibraryFileSyncInfo[];
    extraInTransformation: ILibraryFileSyncInfo[];
    hashMismatches: ILibraryFileSyncMismatch[];
}

export interface ILibraryFileSystemStatusDto {
    libraryPath: string;
    directoryExists: boolean;
    missingFiles: string[];
    allFilesPresent: boolean;
    existingFiles: string[];
}

export interface ILibraryFileSystemCheckResultDto {
    status?: ILibraryFileSystemStatusDto;
    errorMessage?: string;
    statusCode?: number;
}

export interface ILibrarySyncOverviewDto {
    libraryPath: string;
    dbStatus: ILibrarySyncComparisonDto;
    primaryFileSystem: ILibraryFileSystemCheckResultDto;
    bccFileSystem?: ILibraryFileSystemCheckResultDto;
}

export enum IServiceSecurityImplicitType {
  Unknown = -1,
  Public = 0,
  RequiresACL = 1
}

export enum IServiceConsumingType {
    Unknown = -1,
    RequestLib = 10,
    TransformLib = 20,
    Passthrough = 30
}

export enum IAuthenticationType {
    Unknown = -1,
    None = 0,
    HandledByLib = 10,
    Jwt = 20,
    HeaderApiKey = 30
}

export enum IRequestPayloadType {
    Unknown = -1,
    JSON = 10,
    XML =20
}

export interface ITransactionRouteDto {
  id: string
  routeLabel: string
  className: string
  serviceConsumingType: IServiceConsumingType
  transactionMethod?: ITransactionMethod
  authenticationType?: IAuthenticationType
  requestPayloadType?: IRequestPayloadType
  postLocation: string
  accessTokenUrl?: string
  retryInterval?: number
  enabled: boolean
  spokeSubmissionOnly: boolean
  operationType: IOperationType
  serviceId: string
  totalCountTransactionParameters?: number
  isNew: boolean
  isDeleted: boolean;
  isApproved: boolean;
  profileTypeList: string[];
  rootNode?: IClaimConditionNodeDto;
}

export interface ITransactionParameterDto {
    id: string
    transactionId: string
    paramType: IParamType
    paramName: string
    paramValue: string
    paramValueType: IParamValueType
    isDeleted: boolean;
    isLibEditAllowed: boolean;
}


export enum IParamType
{
    Unknown = -1,
    HeaderParam = 0,
    AuthParam = 10
}

export enum IParamValueType
{
    Unknown = -1,
    Bool = 0,
    Int = 1,
    Long = 2,
    Decimal = 3,
    String = 4
}

export enum IDifferenceType {
  Same = 0,
  Different = 1
}

export interface ITransformationsServiceDto {
  id: string;
  name: string;
  code: string;
  createdAt: string;
  modifiedAt?: string;
  isDeleted: boolean;
}

export interface IServiceAggregatorServiceDto {
  id: string;
  name: string;
  code: string;
  ownerId: string;
  serviceSecurityImplicitType: IServiceSecurityImplicitType;
  requireAuthentication: boolean;
  isVisible: boolean;
  submissionAllowed: boolean;
  approvedProfile: boolean;
  enrollementAllowed: boolean;
  willBeActivatedAfterEnrollement: boolean;
  multipleEnrollementsAllowed: boolean;
  canBeDelegatedToAgent: boolean;
  delegationExpiresDays?: number;
  clientAgentCanSendSubmission: boolean;
  approvedDelegation: boolean;
  isDeleted: boolean;
}

export interface IServicesDifferenceDto {
  id: string;
  differenceType: IDifferenceType;
  adminWebService: IServiceDto;
  serviceAggregatorService: IServiceAggregatorServiceDto;
  transformationsService: ITransformationsServiceDto;
  diffColumnsList: string[];
}

export enum ISyncType {
  ServiceAggregator = "SA",
  Transformations = "TR"
}

export enum ITransactionMethod
{
    Unknown = -1,
    GET = 0,
    POST = 1,
    PUT = 2,
    DELETE = 3
}

export enum IOperationType
{
    Unknown = -1,
    Sync = 10,
    Async = 20
}

export interface IServiceAggregatorTransactionRouteDto {
  id?: string;
  className: string;
  serviceConsumingType: IServiceConsumingType;
  transactionMethod: ITransactionMethod;
  authenticationType: IAuthenticationType;
  requestPayloadType: IRequestPayloadType;
  postLocation: string;
  accessTokenUrl?: string;
  retryInterval?: number;
  enabled: boolean;
  operationType: IOperationType;
  serviceId: string;
  isDeleted: boolean;
  isApproved: boolean;
}

export interface ITransformationsTransactionDto {
  id: string;
  className: string;
  postLocation: string; //hostAddress
  authenticationType: IAuthenticationType;
  requestPayloadType: IRequestPayloadType;
  transactionMethod: ITransactionMethod;
  accessTokenUrl?: string;
  serviceConsumingType: IServiceConsumingType;
  serviceId: string;
  createdAt: string;
  modifiedAt?: string;
  isDeleted: boolean;
  isApproved: boolean;
}

export interface ITransactionRoutesDifferenceDto {
  id: string;
  differenceType: IDifferenceType;
  adminWebTransaction: ITransactionRouteDto;
  serviceAggregatorTransaction: IServiceAggregatorTransactionRouteDto;
  transformationsTransaction: ITransformationsTransactionDto;
  diffColumnsList: string[];
}

export interface IServiceAggregatorTransactionParameterDto {
  id?: string
  transactionId: string
  paramType: IParamType
  paramName: string
  paramValue: string
  paramValueType: IParamValueType
  isDeleted: boolean;
}

export interface ITransformationsTransactionParameterDto {
  id: string
  transactionId: string
  paramType: IParamType
  paramName: string
  paramValue: string
  paramValueType: IParamValueType
  createdAt: string;
  modifiedAt?: string;
  isDeleted: boolean;
}

export interface ITransactionParamsDifferenceDto {
  id: string;
  differenceType: IDifferenceType;
  adminWebTransactionParam: ITransactionParameterDto;
  serviceAggregatorTransactionParam: IServiceAggregatorTransactionParameterDto;
  transformationsTransactionParam: ITransformationsTransactionParameterDto;
  diffColumnsList: string[];
}


/**
 * Filter interfaces
 */
export interface IFilterServiceModel {
    id?: string
    name?: string
    code?: string
    transactionName?:string
    serviceSecurityImplicitType?: IServiceSecurityImplicitType
    showDeleted?: boolean
    institutionId: string
}

export interface IFilterInstitutionModel {
    id?: string
    name?: string
    showDeleted?: boolean
}


export interface IFilterAuditLogModel {
    userid?: string
    datefrom?: string
    dateto?: string
    userName?: string
    actionType?: IAuditActionType
    fullName?: string
}
export interface IFilterGatewayLogModel {
    logId?: string
    datefrom?: string
    dateto?: string
    classname?: string
    correlationid?: string
    userid?: string
    userName?: string
    fullName?: string
    logType?: string
    auditLevel?: string
}

export interface IFilterConsumptionLogModel {
    datefrom?: string
    dateto?: string
    spokeName?: string
    className?: string
    consentId?: string
    subjectId?: string
    backendStatusCode?: string
    errorCode?: string
    errorText?: string
    correlationId?: string
}

export interface IFilterConsumptionReportModel {
    from?: string
    to?: string
    spokeName?: string
    className?: string[]
}

export interface IConsumptionLog {
    id?: number
    spokeUserId: string
    spokeName?: string
    className: string
    serviceName?: string
    consentId: string
    subjectId: string
    correlationId: string
    requestTimestamp: string
    responseTimestamp?: string
    responseTimeMs?: number
    backendStatusCode?: number
    gatewayStatusCode?: number
    errorCode?: string
    errorMessage?: string
    callerIp?: string
}

export interface IConsumptionReportRow {
    spokeUserId: string
    spokeName?: string
    className: string
    totalCalls: number
    successfulCalls: number
    clientErrorCalls: number
    serverErrorCalls: number
    avgResponseMs?: number
    p95ResponseMs?: number
}

export interface IConsumptionDashboardTopRow {
    key: string
    displayName?: string
    totalCalls: number
}

export interface IConsumptionDashboard {
    callsToday: number
    callsThisMonth: number
    successfulCallsThisMonth: number
    failedCallsThisMonth: number
    successRateThisMonth: number
    avgResponseMsToday?: number
    latestDay?: string
    topSpokes: IConsumptionDashboardTopRow[]
    topClasses: IConsumptionDashboardTopRow[]
}

export interface IFilterTransactionParameterModel {
    id?: string,
    paramType?: IParamType
    paramName?: string
    paramValue?: string
    paramValueType?: IParamValueType
}

export interface IFilterTransactionRouteModel {
    id?: string,
    routeLabel?: string,
    className?: string,
    postLocation?: string,
    showDeleted?: boolean
}
export interface IFilterLibraryModel {
    name?: string;
    libraryPath?: string;
    serviceId?: string;
    page?: number;
    pageSize?: number;
    sortBy?: string;
    order?: "asc" | "desc";
}


export interface IFilterClaimModel {
    id?: string
    type?: string
    value?: string
    scope?: string
}

export interface IFilterTemplateClaimModel {
    id?: string
    name?: string
}

export interface IFilterStatisticsModel {
    from?: string | Date | null
    to?: string | Date | null
    targetProfileId?: string
    trxName?: string
    nrTrx?: string
}
/**
 * ENDOF Filter interfaces
 */

/**
 * Statistics
 * Note: these mirror the exact (PascalCase) JSON casing returned by the
 * RegisterEnrollment AdminService statistics endpoints, passed through as-is.
 */
export interface IGatewayApiResponse<T> {
    Data: T
    IsSuccess: boolean
    Message: string
    MessageSq: string
    StatusCode: number
}

export interface IUserCountByType {
    Type: string
    Count: number
}

export interface IUserCountSummary {
    Counts: IUserCountByType[]
    Total: number
}

export interface IP2GandG2GCount {
    P2G: number
    G2G: number
    Total: number
}
/**
 * END OF Statistics
 */


export enum ILogicTypeEnum {
    AND = 0,
    OR = 1,
    LEAF = 2,
    ANDNOT = 3,
    ORNOT = 4
}

export interface IClaimDto {
  id: string;
  type: string;
  value?: string;
  scope: string;
}

export interface IClaimAutocompleteResultDto {
  id: string;
  type: string;
  value: string;
}

export enum IDifferenceClaimType {
  Added = 0,  
  Removed = 1,
  Modified = 2
}

export interface IClaimDifferenceDto {
  id: string;
  differenceType: IDifferenceClaimType;
  adminWebClaim: IClaimDto;
  keycloakClaim: IClaimDto;
  diffColumnsList: string[];
}


/**
 * User interfaces
 */
export interface IAccessTokenDecoded {
    exp: number
    iat: number
    auth_time: number
    jti: string
    iss: string
    aud: string[]
    sub: string
    typ: string
    azp: string
    sid: string
    acr: string
    "allowed-origins": string[]
    realm_access: IRealmAccess
    resource_access: IResourceAccess
    scope: string
    unique_name: string
    email_verified: boolean
    legacyusername: string
    roles: string[]
    name: string
    otpmethod: string
    preferred_username: string
    given_name: string
    locale: string
    family_name: string
    email: string
}

export interface IRealmAccess {
    roles: string[]
}

export interface IResourceAccess {
    "realm-management": IRealmManagement
    "account-console": IAccountConsole
    account: IAccount
}

export interface IRealmManagement {
    roles: string[]
}

export interface IAccountConsole {
    roles: string[]
}

export interface IAccount {
    roles: string[]
}
/**
 * ENDOF User interfaces
 */


/**
 * Audit Logs
 */
export interface IAuditLog {
    auditId: number
    actorId: string
    userId: string
    ipAddress: string
    clientAppId: string
    actionType: IAuditActionType
    entityType: IAuditEntityType
    sourceSystem: IAuditSourceSystem
    oldValue: any
    newValue: any
    changes: any
    timestamp: string
    reason: string
    errorMsg: any
    currentStage: any
    className: string
    correlationId: string
    userName: string
    fullName: string
    actorUserName?: string;
    actorFullName?: string;
}

export enum IAuditActionType {
    Unknown = 0,
    Action = 1,
    Create = 2,
    Update = 3,
    Delete = 4,
    Login = 5,
    Verify = 6,
    OtpEmailSent = 7,
    OtpSmsSent = 8,
    OtpEmailCcSent = 9,
}
export enum IAuditEntityType {
    Unknown = 0,
    User = 1,
    Role = 2,
}
export enum IAuditSourceSystem {
    Unknown = 0,
    Keycloak = 1,
    Transformations = 2,
    Notifications = 3,
}
/**
 * END OF Audit Logs
 */

/**
 * Gateway Logs
 */
export interface IGatewayLog {
  logId: number
  className: string
  correlationId: string
  logMessage: string
  logType: ILogType
  auditLevel: IAuditLevel
  traceEventType: number | null
  createdAt: string
  userId: string
  userName: string
  fullName: string
}
export enum ILogType
{
    DIS_REQUEST = 1,
    DIS_RESPONSE,
    SERVICE_REQUEST,
    SERVICE_RESPONSE,
    DIS_EXCEPTION
}
export enum IAuditLevel
{
    AuditLevel1 = 1,
    AuditLevel2
}
/**
 * END OF Gateway Logs
 */

export interface ITemplateClaimDto {
  id: string;
  name: string;
}

export interface IBaseConditionNode<TNode> {
  id: string;
  parentId?: string | null;
  logicType: ILogicTypeEnum;
  claimId?: string | null; // only for leaf nodes
  orderIndex: number;
  children: TNode[];
  negated?: boolean; // for logic NOT
  customValue?: string | null; // for claim
}

export interface IClaimConditionNodeDto extends IBaseConditionNode<IClaimConditionNodeDto> {
  transactionId: string;
}

export interface ITemplateConditionNodeDto extends IBaseConditionNode<ITemplateConditionNodeDto> {
  templateClaimId: string;
}

export interface ISaveTemplateClaimAndLogicRequestDto {
  templateClaim: ITemplateClaimDto;
  rootNode: ITemplateConditionNodeDto;
}

/**
 * Profile DTOs used by user profile pages
 */
export interface IProfileFilterDto {
  Username?: string;
  FirstName?: string;
  LastName?: string;
  Fullname?: string;
  Email?: string;
  MobileNumber?: string;
  ProfileId?: string;
  Exact?: boolean;
  ProfileType?: string;
  Category?: string;
  First?: number;
  Max?: number;
}

export interface IProfileItemDto {
    UserId?: string;
  ProfileId?: string;
  Username?: string;
  FirstName?: string;
  LastName?: string;
  Name?: string;
  Fullname?: string;
  ProfileState?: string;
  Approved?: boolean;
  Email?: string;
  MobileNumber?: string;
  Attributes?: Record<string, string> | null;
}
export interface IProfileDetailsDto{
    UserId?: string;
    IsMainUser?: boolean;
    CreatedBy?: string | null;
    Description?: string;
    Category?: string;
    ProfileId?: string;
    PPID?: string;
    IdpRealm?: string;
    LanguageCode?: string;
    Roles?: string[];
    UnmanagedClaims?: string[];
    Name?: string;
    Username?: string;
    UserType?: string;
    Email?: string;
    ProfileState?: string;
    Approved?: boolean;
    Unlocked?: boolean;
    MobileNumber?: string;
    ProfileType?: string;
    ClearMobileNumber?: boolean;
    EmailVerified?: boolean;   
}
export interface IFilterProfileEventsModel {
    userId?: string
    profileId?: string
    userName?: string
    fullName?: string
    actionTypes?: (number | string)[]
    dateFrom?: string | Date | null
    dateTo?: string | Date | null
}

export interface IProfileClaimsDto{
    Type: string;
    Value: string;
    Group?: string | null;
    Issuer?: string | null;
    Realm?: string | null;
    ValueType?: string | null;
}

    export interface IClaimScopeDto extends IProfileClaimsDto{
        ClientScope: string;
    }
